import React from 'react';
import {
  Badge,
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  Icon,
  Link,
  SimpleGrid,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiExternalLink, FiMail, FiShield, FiClock } from 'react-icons/fi';

const FooterPortalCiudadano = () => {
  const year = new Date().getFullYear();
  const bg = useColorModeValue('rgba(255,255,255,.86)', 'navy.800');
  const border = useColorModeValue('rgba(161,38,61,.14)', 'whiteAlpha.200');
  const muted = useColorModeValue('#756b63', 'gray.300');

  return (
    <Box as="footer" px={{ base: 3, md: 6 }} pb={6} pt={3}>
      <Box
        bg={bg}
        border="1px solid"
        borderColor={border}
        borderRadius="26px"
        overflow="hidden"
        boxShadow="0 18px 44px rgba(53, 36, 28, 0.08)"
      >
        <Box h="5px" bg="linear-gradient(90deg, #681a2d 0%, #A1263D 48%, #d79b52 100%)" />
        <SimpleGrid columns={{ base: 1, lg: 3 }} spacing={{ base: 5, lg: 8 }} p={{ base: 5, md: 6 }}>
          <VStack align="flex-start" spacing={2}>
            <Badge bg="#fff0e1" color="#7a1b31" borderRadius="full" px={3} py={1}>
              Ayuntamiento de Totolac
            </Badge>
            <Text fontWeight="900" fontSize="lg" color="#231b18">
              Sistema Administrativo Municipal
            </Text>
            <Text fontSize="sm" color={muted} maxW="420px">
              Plataforma interna para gestion, seguimiento y trazabilidad de tramites municipales.
            </Text>
          </VStack>

          <VStack align="flex-start" spacing={3}>
            <FooterMeta icon={FiShield} label="Entorno seguro" text="Acceso controlado por usuario y rol." />
            <FooterMeta icon={FiClock} label="Operacion" text="Disponible para atencion administrativa." />
          </VStack>

          <VStack align={{ base: 'flex-start', lg: 'flex-end' }} spacing={3}>
            <HStack spacing={2} flexWrap="wrap">
              <Button
                as={Link}
                href="mailto:soporte@togui.com"
                size="sm"
                leftIcon={<FiMail />}
                bg="#681a2d"
                color="white"
                _hover={{ bg: '#7f2036', textDecoration: 'none' }}
              >
                Soporte
              </Button>
             
            </HStack>
            <Text fontSize="xs" color={muted} textAlign={{ base: 'left', lg: 'right' }}>
              Version operativa municipal. Use informacion sensible solo conforme a sus permisos.
            </Text>
          </VStack>
        </SimpleGrid>

        <Divider borderColor={border} />
        <Flex
          px={{ base: 5, md: 6 }}
          py={3}
          justify="space-between"
          align={{ base: 'flex-start', md: 'center' }}
          direction={{ base: 'column', md: 'row' }}
          gap={2}
          bg="#faf7f3"
        >
          <Text fontSize="xs" color={muted}>
            © {year} TOGUI TECNO INNOVACIONES. Todos los derechos reservados.
          </Text>
          <Text fontSize="xs" color={muted}>
            Totolac, Tlaxcala · Gobierno Municipal
          </Text>
        </Flex>
      </Box>
    </Box>
  );
};

const FooterMeta = ({ icon, label, text }: { icon: any; label: string; text: string }) => (
  <HStack align="flex-start" spacing={3}>
    <FlexIcon icon={icon} />
    <Box>
      <Text fontSize="sm" fontWeight="800" color="#231b18">{label}</Text>
      <Text fontSize="xs" color="#756b63">{text}</Text>
    </Box>
  </HStack>
);

const FlexIcon = ({ icon }: { icon: any }) => (
  <Flex
    w="34px"
    h="34px"
    align="center"
    justify="center"
    borderRadius="13px"
    bg="#fff0e1"
    color="#A1263D"
    flexShrink={0}
  >
    <Icon as={icon} />
  </Flex>
);

export default FooterPortalCiudadano;
